<div class="p-4 md:p-8" style="max-width: 520px; margin: 0 auto;">

  <!-- Header -->
  <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-bottom: 24px;">
    <img src="assets/icons/zelle.png" alt="Zelle" style="width: 28px; height: 28px; object-fit: contain;">
    <h1 style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; margin: 0;">Zelle</h1>
  </div>

  <!-- Card -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">

    <!-- Tipo de cambio header -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 12px 24px; border-bottom: 2px solid #bbf7d0; text-align: center;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de cambio</span>
    </div>

    <!-- Rates grid -->
    <div class="grid grid-cols-2" style="border-bottom: 1px solid #e5e7eb;">
      <div style="padding: 14px 24px; text-align: center; border-right: 1px solid #e5e7eb;">
        <div style="display: flex; align-items: center; justify-content: center; gap: 6px; margin-bottom: 4px;">
          <img src="assets/icons/zelle.png" alt="Zelle" style="width: 18px; height: 18px; object-fit: contain;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Compra</span>
        </div>
        <p *ngIf="hasLoaded" style="font-size: 1rem; font-weight: 700; color: #1e5a3f; margin: 0;">
          {{ zelleSellValue | number:'1.0-2' }} CLP <span style="font-size: 0.75rem; font-weight: 500; color: #9ca3af;">= 1 USD</span>
        </p>
        <img *ngIf="!hasLoaded" src="assets/loader.svg" height="36" width="36" style="margin: 4px auto 0;" alt="">
      </div>
      <div style="padding: 14px 24px; text-align: center;">
        <div style="display: flex; align-items: center; justify-content: center; gap: 6px; margin-bottom: 4px;">
          <img src="assets/icons/zelle.png" alt="Zelle" style="width: 18px; height: 18px; object-fit: contain;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Venta</span>
        </div>
        <p *ngIf="hasLoaded" style="font-size: 1rem; font-weight: 700; color: #1e5a3f; margin: 0;">
          {{ zelleBuyValue | number:'1.0-2' }} CLP <span style="font-size: 0.75rem; font-weight: 500; color: #9ca3af;">= 1 USD</span>
        </p>
        <img *ngIf="!hasLoaded" src="assets/loader.svg" height="36" width="36" style="margin: 4px auto 0;" alt="">
      </div>
    </div>

    <!-- Saldo Actual -->
    <div style="padding: 14px 24px; text-align: center;"
      [style.border-bottom]="(lineaCredito! > 0 && !lineaCreditoBloqueada) || lineaCreditoBloqueada ? '1px solid #e5e7eb' : 'none'">
      <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
        <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo Actual</span>
      </div>
      <p [ngStyle]="{ display: hasLoaded ? '' : 'none' }" style="font-size: 1.1rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">
        ${{ saldoActual | currency:'':'' }} CLP
      </p>
      <img *ngIf="!hasLoaded" src="assets/loader.svg" height="36" width="36" style="margin: 4px auto 0;" alt="">
    </div>

    <!-- Contable + Sobregiro -->
    <div *ngIf="lineaCredito! > 0 && !lineaCreditoBloqueada" class="grid grid-cols-2">
      <div style="padding: 12px 24px; text-align: center; border-right: 1px solid #e5e7eb;">
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">Saldo Contable</span>
        <p [ngStyle]="{ display: hasLoaded ? '' : 'none' }" style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">
          ${{ saldoContable | currency:'':'' }}
        </p>
        <img *ngIf="!hasLoaded" src="assets/loader.svg" height="36" width="36" style="margin: 4px auto 0;" alt="">
      </div>
      <div style="padding: 12px 24px; text-align: center;">
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">Sobregiro</span>
        <p [ngStyle]="{ display: hasLoaded ? '' : 'none' }" style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">
          ${{ sobregiroDisponible | currency:'':'' }}
        </p>
        <img *ngIf="!hasLoaded" src="assets/loader.svg" height="36" width="36" style="margin: 4px auto 0;" alt="">
      </div>
    </div>

    <!-- Línea bloqueada -->
    <div *ngIf="lineaCreditoBloqueada"
      style="padding: 10px 24px; border-top: 1px solid #e5e7eb; background: #fef2f2; text-align: center;">
      <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626; vertical-align: middle; margin-right: 4px;">warning</mat-icon>
        Su línea de crédito se encuentra bloqueada
      </span>
    </div>

  </div>

  <!-- Botones -->
  <button type="button" routerLink="/wallet/client/send-zelle"
    style="width: 100%; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; margin-bottom: 12px;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <span style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; background: white; border-radius: 50%;">
      <img src="assets/icons/zelle.png" alt="Zelle" style="width: 16px; height: 16px; object-fit: contain;">
    </span>
    Enviar Zelle
  </button>
  <div style="display: flex; gap: 12px;">
    <button type="button" routerLink="/wallet/client/rechargeAccount"
      style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <img src="assets/flags/chile.png" alt="CLP" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover;">
      Recargar Saldo
    </button>
    <button type="button" (click)="redirectToExternalLink()"
      style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">storefront</mat-icon>
      Vender Zelle
    </button>
  </div>

</div>
